import { useContext } from "react";
import { WorkflowState } from "../contexts/workflow-state";

// Hook
function useWorkflowState() {
  return useContext(WorkflowState)
}

export default useWorkflowState
